export * from './delete-erforderliches-dokument.service';
export * from './delete-erforderliches-dokument.service.module';